import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import StatusPill from "@/components/site/StatusPill";
import DownloadButton from "@/components/site/DownloadButton";

const EMBERS = Array.from({ length: 22 }, (_, i) => ({
  id: `ember-${i}`, left: (i * 37) % 100, delay: (i * 0.7) % 9, dur: 7 + ((i * 3) % 7), size: 2 + (i % 3),
}));

export default function Hero({ settings }) {
  return (
    <header id="top" className="relative flex flex-col bg-[#05060f] md:min-h-[100svh]" data-testid="site-hero">
      {/* the scene of the game's login screen; on phones it is shown whole above the text */}
      <div className="relative w-full md:absolute md:inset-0 overflow-hidden">
        <motion.img src="/assets/koselig-hero.jpg" alt={settings.server_name} initial={{ scale: 1.06, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 1.6, ease: [0.2, 0.8, 0.2, 1] }}
          className="block w-full h-auto md:h-full md:object-cover md:object-[50%_30%] mt-14 md:mt-0" data-testid="site-hero-logo" />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#05060f] via-[#05060f]/70 to-transparent" />
        <div className="hidden md:block absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,transparent_45%,#05060f_100%)]" />
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          {EMBERS.map((e) => (
            <span key={e.id} className="ember" style={{ left: `${e.left}%`, width: e.size, height: e.size, animationDelay: `${e.delay}s`, animationDuration: `${e.dur}s` }} />
          ))}
        </div>
        <div className="grain absolute inset-0 pointer-events-none" />
      </div>

      <div className="relative z-10 mt-auto w-full max-w-7xl mx-auto px-6 md:px-10 pt-6 pb-20 md:pb-28 flex flex-col items-center text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }}>
          <StatusPill />
        </motion.div>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8, duration: 0.8 }}
          className="mt-6 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed">
          Koselig2 - Nowatorskie podejście do klasyki.
        </motion.p>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1, duration: 0.8 }}
          className="mt-9 flex flex-col sm:flex-row gap-4">
          <Link to="/rejestracja" className="btn btn-primary" data-testid="hero-register-btn"><UserPlus size={18} /> Załóż konto</Link>
          <DownloadButton settings={settings} testId="hero-download-btn" />
        </motion.div>
      </div>
    </header>
  );
}
